import { useState } from 'preact/hooks';
import { GOLD, TEXT_BODY } from '../../lib/medievalTheme';
import { getClass } from '../../utils/arena/classes';
import { isAlchemist } from '../../utils/arena/alchemist';
import { playUI, UI } from '../../utils/arena/uiSounds';
import { Tooltip } from '../ui/tooltip';
import { IconAlchemyFlask } from '../ui/icons';
import { t } from '../../localization/t';

// The door to the laboratory, first in the header when the player is an
// Alchemist. Dispatches `vh:open-laboratory`, which app.jsx catches, so
// no AppHeader caller has to thread a callback through.
export default function LaboratoryButton({ profile }) {
  const [hover, setHover] = useState(false);
  if (!isAlchemist(profile?.skills)) return null;
  const accent = getClass('alchemist').accent;
  const tint = (a) => `${accent}${Math.round(a * 255).toString(16).padStart(2, '0')}`;
  const brewing = Object.keys(profile?.alchemist?.active || {}).length > 0;
  return (
    <Tooltip side="bottom" content={<div className="font-normal">{t('Enter your laboratory to brew and drink potions.')}</div>}>
      <button
        type="button"
        data-tutorial="laboratory"
        data-testid="laboratory-button"
        onClick={() => { playUI(UI.CLICK); window.dispatchEvent(new CustomEvent('vh:open-laboratory')); }}
        onMouseEnter={() => { setHover(true); playUI(UI.HOVER, { volume: 0.3 }); }}
        onMouseLeave={() => setHover(false)}
        className="relative flex items-center justify-center w-9 h-9 rounded-full transition-all cursor-pointer"
        style={{
          background: hover ? tint(0.14) : 'rgba(14,12,8,0.55)',
          border: `1.5px solid ${hover ? tint(0.6) : `${GOLD} 0.25)`}`,
          boxShadow: hover ? `0 0 10px ${tint(0.3)}, 0 2px 6px rgba(0,0,0,0.4)` : '0 2px 6px rgba(0,0,0,0.35)',
        }}
      >
        <IconAlchemyFlask size={17} style={{ color: hover || brewing ? accent : TEXT_BODY }} />
        {brewing ? (
          <span aria-hidden className="absolute rounded-full" style={{ top: '0.1cqw', right: '0.1cqw', width: '0.5cqw', height: '0.5cqw', background: accent, boxShadow: `0 0 0.5cqw ${accent}` }} />
        ) : null}
      </button>
    </Tooltip>
  );
}
